module.exports = __webpack_public_path__ + "img/featured-vehicle-row-23-hyundai.c820b664.jpg";